import '../styles/globals.css'
import 'slick-carousel/slick/slick.css'
import '../styles/slick-theme.css'
import '../styles/slick.css'
import '../styles/style.css'
import type { AppProps } from 'next/app'
import { Fragment } from 'react'
import Head from 'next/head'
import TapFiliate from 'components/core/TapFiliate'

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <Fragment>
      <TapFiliate />
      <Head>
        <link rel="icon" type="image/x-icon" href="/favicon.png" />
        <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400;500;700&family=Open+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </Head>
      <Component {...pageProps} />
    </Fragment>
  )
}

export default MyApp
